<template>
  <div class="c-form-items-form">
    <div class="form-body">
      <c-form ref="formRef" v-bind="innerFormAttrs" :model="props.model">
        <c-form-items ref="formItemsRef" v-bind="innerFormItemsAttrs" :model="props.model" />
      </c-form>
      <div class="form-actions text-center">
        <el-button @click="cancel">取消</el-button>
        <el-button v-preventReclick :loading="loading" type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { ref, reactive, computed, useCurrentAppInstance } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: any
    prop: string
    items?: any[]
    formAttrs?: any
    formItemsAttrs?: any
    confirmMessage?: boolean | string | Function
    onSubmit?: Function
  }>(),
  {}
)

const app = useCurrentAppInstance()
const { MessageBox } = app.useMessage()

const emit = defineEmits(['cancel', 'submit'])

const formRef = ref<any>()
const loading = ref<boolean>(false)

// 表单属性
const innerFormAttrs = computed(() => {
  return {
    ...props.formAttrs
  }
})

// 表单项属性
const innerFormItemsAttrs = computed(() => {
  return {
    showOperation: false,
    span: 24,
    items: props.items,
    ...props.formItemsAttrs
  }
})

// 编辑状态下，是否二次确认的判断
const editorMessageBox = () => {
  return new Promise((resolve, reject) => {
    let message = props?.confirmMessage

    if (typeof message === 'string') {
      // message = message
    } else if (typeof message === 'function') {
      message = message(props?.model)
    } else {
      resolve(true)
      return false
    }

    if (message) {
      MessageBox.confirm(message, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          resolve(true)
        })
        .catch(() => {
          reject()
        })
    } else {
      resolve(true)
    }
  })
}

/** 提交-走校验 */
const submit = () => {
  if (!formRef) return
  formRef.value.validate((value: any) => {
    if (value) {
      editorMessageBox().then(() => {
        onSubmit()
      })
    } else {
      console.log('error submit')
      return false
    }
  })
}

/** 提交-请求 */
async function onSubmit() {
  if (loading.value) return

  loading.value = true
  try {
    const appContext = app.useContext(props.model)

    if (props.onSubmit) {
      const res = Promise.resolve().then(() => {
        return props.onSubmit!(appContext)
      })
    }

    emit('submit')

    loading.value = false
  } catch (ex) {
    loading.value = false
  }
}

/** 取消 */
function cancel() {
  emit('cancel')
}
</script>

<style lang="scss" scoped>
.c-form-items-form {
  // width: 500px;
}
</style>
